import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="m31.243 15.03-3.382-.845A11.98 11.98 0 0 0 17.815 4.139L16.97.764a1 1 0 0 0-1.94 0l-.845 3.381A11.98 11.98 0 0 0 4.139 14.191l-3.375.845a1 1 0 0 0 0 1.94l3.381.845a11.98 11.98 0 0 0 10.046 10.046l.845 3.382a1 1 0 0 0 1.94 0l.845-3.381A11.98 11.98 0 0 0 27.867 17.82l3.382-.845a1 1 0 0 0 0-1.94Zm-11.937 2.863L17.414 16l1.892-1.892L26.875 16Zm-6.612 0L5.125 16l7.571-1.892L14.586 16ZM25.72 13.65l-5.896-1.475-1.475-5.896a9.99 9.99 0 0 1 7.371 7.371m-7.828-.956L16 14.586l-1.892-1.892L16 5.125ZM13.65 6.279l-1.475 5.896-5.896 1.475a9.99 9.99 0 0 1 7.371-7.371M6.275 18.35l5.9 1.475 1.475 5.896a9.99 9.99 0 0 1-7.371-7.371Zm7.829.956L16 17.414l1.893 1.892L16 26.875Zm4.242 6.415 1.475-5.896 5.897-1.475a9.99 9.99 0 0 1-7.368 7.371Z"
    />
  </svg>
);
const SvgIconClientUpdates = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconClientUpdates);
export default Memo;
